export default {
  name: 'customPopup',
  components: {
  },
  props: {
    isVisibleProp: {
      type: Boolean,
      default () { return false }
    }
  },
  watch: {
    isVisibleProp (newisVisible) {
      this.isVisible = newisVisible
    }
  },
  mixins: [],
  data () {
    return {
      isVisible: this.isVisibleProp
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('custom-popup-change', { action, payload: { data } })
      }
    },
    handleCloseModal () {
      this.isVisible = false
      this.emitEvent('POPUP_CLOSED', { visible: false })
    }
  },
  mounted () {}
}
